import styled from 'styled-components'

import { ContainerHeaderAccordionProps } from './interfaces'

export const ContainerAccordion = styled.div`
  background: ${({ theme }) => theme.color.background.neutral.default};
  position: relative;
  border: ${({ theme }) => theme.border.width.thinner} ${({ theme }) => theme.border.style.solid}
    ${({ theme }) => theme.color.border.neutral.default};
  border-radius: ${({ theme }) => theme.border.radius.large};
  padding: ${({ theme }) => theme.spacing.km6} ${({ theme }) => theme.spacing.km10};
`
export const Divider = styled.div`
  margin: ${({ theme }) => theme.spacing.km6} ${({ theme }) => theme.spacing.km0};
  border: ${({ theme }) => theme.border.width.thinner} ${({ theme }) => theme.border.style.solid}
    ${({ theme }) => theme.color.border.neutral.default};
`

export const ContentAccordion = styled.div<ContainerHeaderAccordionProps>`
  transition: max-height 0.5s ease-out;
  overflow: auto;
  padding-right: ${({ theme }) => theme.spacing.km3};
  max-height: ${({ theme }) => theme.spacing.km0};

  ${({ isOpen, theme }) => !isOpen && `transform: scaleY(0); padding: ${theme.spacing.km0};`}
`

export const HeaderAccordion = styled.div`
  display: flex;
  background: ${({ theme }) => theme.color.background.neutral.default};
  align-items: center;
  gap: ${({ theme }) => theme.spacing.km5};

  @media (max-width: ${({ theme }) => theme.breakpoint.md.maxWidth}) {
    align-items: center;
  }
`

export const ContainerHeaderAccordion = styled.div`
  position: sticky;
  top: 0;
  z-index: ${({ theme }) => theme.zIndex.absolute};
  background: ${({ theme }) => theme.color.background.neutral.default};
`
export const AccordionButton = styled.div`
  @media (max-width: ${({ theme }) => theme.breakpoint.md.minWidth}) {
    position: absolute;
    right: -10px;
    top: -10px;
  }
`

export const ContentHeader = styled.div`
  width: 100%;
`
